import { useTranslation } from 'react-i18next'
import { Perils } from '@/components/Perils/Perils'
import { useMissingPerils } from '@/components/Perils/useMissingPerils'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { Badge } from 'ui/src/components/Badge/Badge'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { grid } from './TierCoverageInfoDialogContent.css'

type Props = {
  title: string
  subtitle: string
  selectedOffer: ProductOfferFragment
}

export function TierCoverageInfoDialogContent({ title, subtitle, selectedOffer }: Props) {
  const { t } = useTranslation(['common', 'purchase-form'])
  const perils = selectedOffer.variant.perils
  const missingPerils = useMissingPerils(perils)

  return (
    <LargeDialog.Content>
      <LargeDialog.CloseIconButton aria-label={t('common:DIALOG_CLOSE')} />
      <LargeDialog.Heading as="h2">{title}</LargeDialog.Heading>
      <LargeDialog.Heading as="h3" color="textSecondary" className={sprinkles({ marginBottom: 'xl' })}>
        {subtitle}
      </LargeDialog.Heading>
      <div className={yStack({ gap: 'xxl' })}>
        <div>
          <Badge as="h3" className={sprinkles({ marginBottom: 'md' })} variant="grey1" size="small">
            {t('purchase-form:TIER_COVERAGE_DIALOG_HEADING')}
          </Badge>
          <Perils items={selectedOffer.variant.perils} missingItems={missingPerils} />
        </div>

        <div className={grid}>
          {selectedOffer.variant.insurableLimits.map((item) => (
            <div className={sprinkles({ paddingBottom: 'lg' })} key={item.label}>
              <Badge as="h3" className={sprinkles({ marginBottom: 'md' })} variant="grey1" size="small">
                {item.label}
              </Badge>
              <Text size="md">{item.limit}</Text>
              <Text size="md" color="textSecondary" balance={true}>
                {item.description}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </LargeDialog.Content>
  )
}
